import {styled, useTheme} from '@mui/material/styles'

type Step = {
  key: string,
  title: string,
}

type StepperProps = {
  steps: Step[],
  currentStep: number,
}

const StepSegment = styled('div', {shouldForwardProp: (prop) => prop !== 'filled'})<{filled: boolean}>(({theme, filled}) => ({
  width: '40px',
  height: '4px',
  borderRadius: '2px',
  backgroundColor: filled ? theme.palette.primary.main : '#C2C2C2'
}))

const Stepper: React.FC<StepperProps> = ({steps, currentStep}) => {
  const theme = useTheme()
  const nextStep = steps[currentStep + 1]

  return (
    <div style={{display: 'flex', flexDirection: 'column', gap: '8px'}}>
      <span style={{fontSize: '16px', color: theme.palette.primary.main}}>
        {`Step ${currentStep + 1} di ${steps.length} `}
        <b>{steps[currentStep]?.title}</b>
      </span>
      <div style={{display: 'flex', gap: '4px'}}>
        {steps.map((step, index) => (
          <StepSegment filled={index <= currentStep} key={step.key} />
        ))}
      </div>
      {nextStep && (
        <span style={{fontSize: '12px', color: '#707070'}}>
          {`Next step: ${nextStep.title}`}
        </span>
      )}
    </div>
  )
}

export default Stepper
